import { useState, useEffect } from 'react';
import { format } from 'date-fns';

import './Shows.sass';

function transformEvent(event) {
  return {
    title: event.summary,
    description: event.description,
    location: event.location,
    locationLink: 'https://www.google.com/maps/search/?api=1&query=' +
      encodeURI(event.location),
    startTime: event.start,
    endTime: event.end
  }
}

function Shows() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const apiKey = 'AIzaSyD4Xzr9Rz3Xejb7erqOOivPGXk5x7VvjN8';
  const calId = '8fl0id73hhj5sea3gf7jmg5h2o@group.calendar.google.com';

  useEffect(() => {
    fetch('https://www.googleapis.com/calendar/v3/calendars/' + calId +
      '/events?orderBy=startTime&singleEvents=true&key=' + apiKey)
      .then(response => response.json())
      .then(json => {
        if(json && json.items && json.items.length) {
          let recurringIds = [];
          let events = [];
          json.items.forEach((event) => {
            if (new Date() < new Date(event.end.dateTime || event.end.date)) {
              if (!(event.recurringEventId &&
                recurringIds.includes(event.recurringEventId))) {
                events.push(transformEvent(event));
                if (event.recurringEventId) {
                  recurringIds.push(event.recurringEventId);
                }
              }
            }
          });
          setData(events);
          setLoading(false);
        }
      })
      .catch(error => console.error(error));
  }, []);

  return (
    <div className="ShowsPane">
      {loading && <div className="LoaderContainer">
        <div className="loader"></div>
      </div>}
      {data.map((event, index) => (
        <div key={event.title} className="EventBlock" style={{animationDelay: index * 0.1 + 's'}}>
          <div className="InfoBlock">
            <h2>{event.title}</h2>
            {event.startTime.date &&
              <p>{format(new Date(event.startTime.date), 'MMMM d, yyyy')}</p>}
            {event.startTime.dateTime &&
              <p>{format(new Date(event.startTime.dateTime), 'MMMM d, yyyy')}</p>}
            {event.startTime.dateTime &&
              <p>{format(new Date(event.startTime.dateTime), 'h:mm a')} -
                {format(new Date(event.endTime.dateTime), 'h:mm a')}</p>}
          </div>
          <div className="TextBlock">
            <p className="Description"
              dangerouslySetInnerHTML={{__html: event.description}}></p>
            <a className="Directions" href={event.locationLink}
              target="_blank" rel="noreferrer">
              {window.innerWidth > 800 ? event.location : 'Directions'}</a>
          </div>
        </div>
      ))}
    </div>
  )
}

export default Shows;
